import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetContentfulSupportCategoriesRequest } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'
import { GetContentfulSupportCategoriesResponse } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'

export const getContentfulSupportCategories = (
  request: GetContentfulSupportCategoriesRequest,
  options?: CashRequestOptions
) =>
  post<GetContentfulSupportCategoriesRequest, GetContentfulSupportCategoriesResponse>(
    '/2.0/cash/get-contentful-support-categories',
    request,
    { ...options, rejectOnError: true }
  )
